import { createMutableAction } from '@bimser/core';
import * as ActionTypes from './actionTypes';

export function closeObjectSelectAction() {
	return createMutableAction(ActionTypes.CLOSE_OBJECT_SELECT_POPOVER_ACTION, null);
}
